<div class="text-left">
  <div [ngClass]="{'disabled-val': departmentSelect.disabled == true}" class="selectDepartment"><b>Department</b></div>
  <div class="relative">
    <ng-select #departmentSelect [items]="newlyAdded" bindLabel="text" bindValue="" [disabled]="true" [multiple]="true"
      [closeOnSelect]="false" [loading]="departmentLoading" [typeahead]="departmentInput$" typeToSearchText="Department"
      [virtualScroll]="true" [(ngModel)]="selectedDepartment"></ng-select>
    <i [ngClass]="{'disabled-val': departmentSelect.disabled == true}" class="fa fa-search"></i>
  </div>
</div>